import React from 'react';
import { Box, TextField, Alert, Typography } from '@mui/material';

import { MethodEditorProps } from '../types';

export const DelayEditor: React.FC<MethodEditorProps> = ({ payload, onChange }) => (
  <Box>
    <TextField
      fullWidth
      type="number"
      value={payload?.delay || 1000}
      onChange={(e) => onChange({ ...payload, delay: parseInt(e.target.value, 10) })}
      label="Delay (milliseconds)"
      helperText="Time to wait before continuing to the next action"
      margin="normal"
    />
    <Alert severity="info" sx={{ mt: 2 }}>
      <Typography variant="body2">
        Use delays to control timing between actions, create dramatic pauses, or allow time for
        users to read messages.
      </Typography>
    </Alert>
  </Box>
);
